import classNames from 'classnames';
import { Link } from 'react-router-dom';

import CapsuleAccordion from 'src/app/components/Elements/Accordion';
import LinkButton from 'src/app/components/Elements/Button/LinkButton';
import StandardPage from 'src/app/components/Elements/Page/Standard';
import { medications, questions } from 'src/app/router/paths';

import faqQuestions from '../questions';

import styles from './styles.module.scss';

const loggedInTransferFAQ = () => {
  return (
    <div className={styles.container}>
      <StandardPage>
        <div className={styles.pageInner}>
          <h1 className={classNames(styles.pageTitle, 'title-2', 'strong')}>
            Our friendly pharmacists are always here to help!
          </h1>
          <CapsuleAccordion
            className={styles.accordion}
            questions={faqQuestions.baseQuestions}
            wrapperClassName={'py-4'}
            bodyClassName={classNames(styles.body, 'accordion__panel')}
            name="pages-logged-in-transfer"
          />
          <p className="normal">
            Have additional questions?
            <br />
            Check out our{' '}
            <Link className="red" to={questions.toPath()}>
              FAQs
            </Link>
            <br />
            Call or text us at{' '}
            <a href="tel:2126753900" className="strong">
              (212) 675-3900
            </a>
            <br />
            Or email{' '}
            <a href="mailto:help@capsule.com" className="strong">
              help@capsule.com
            </a>
            <br />
          </p>
          <LinkButton to={medications.toPath()} size="medium" style="secondary" block>
            OK
          </LinkButton>
        </div>
      </StandardPage>
    </div>
  );
};

export default loggedInTransferFAQ;
